/**
 * Single source of truth for embed-capable products.
 * When adding a new embed-capable product, add an entry here with its
 * product name(s) and URL domain patterns.
 */
export const EMBED_CAPABLE_PRODUCTS = [
	{
		productNames: ['Loom'],
		urlPatterns: ['loom.com'],
	},
	{
		productNames: ['Google Drive', 'Google', 'GoogleDrive'],
		urlPatterns: ['drive.google.com', 'docs.google.com', 'sheets.google.com', 'slides.google.com'],
	},
] as const;

/**
 * Product name lookup used by KnowledgeSmartCard to determine embed rendering.
 * Derived from EMBED_CAPABLE_PRODUCTS.
 */
export const EMBEDDED_SOURCE_PRODUCTS = Object.fromEntries(
	EMBED_CAPABLE_PRODUCTS.flatMap(({ productNames }) =>
		productNames.map((name) => [name, name]),
	),
) as Record<string, string>;

